import '../../css/GenericBuilder/diamondModal.css';
import '../../css/SingleRingBuilder/DiamondCard.css';
import React, { useEffect, useState, useContext, useMemo } from 'react';
import ReactDOM from 'react-dom';
import DataTable from "react-data-table-component";
import { CONSTANT } from '../utils/constants';
import axios from 'axios';
import { GlobalContext } from '../utils/GlobalContext';
import { isDiamondPriceHidden } from '../utils/helpers';
import  { DiamondDetailsModal } from '../Modal/DiamondDetailsModal';
import AIRecommendedDiamonds from '../Pages/AIRecommendedDiamonds';
import Slider from 'rc-slider';

import 'rc-slider/assets/index.css';


// Certificate options available per client code.
// Clients not listed here will see all options.
const ALL_CERT_OPTIONS = [
    { value: 'all',     label: 'All' },
    { value: 'GIA',     label: 'GIA' },
    { value: 'IGI',     label: 'IGI' },
    { value: 'GCAL',    label: 'GCAL' },
    { value: 'GHI',     label: 'GHI' },
    { value: 'HRD',     label: 'HRD' },
    { value: 'IGI-SCS', label: 'IGI-SCS' },
    { value: 'NCERT',   label: 'NCERT' },
    { value: 'AGS',     label: 'AGS' },
];

const CERT_OPTIONS_BY_CLIENT = {
    W058: ['all', 'GIA', 'IGI'],
    // Add more client codes and their allowed cert types below:
    // W123: ['all', 'GIA', 'GCAL'],
    // W999: ['all', 'GIA', 'IGI', 'GCAL'],
};

export const AjaxDiamond = ({ toggleDiamondModal, handleSelectedDiamondDetails, onStoneSizeChange }) => {
    // Color and Clarity label arrays defined first so they can be used in useState initializers
    const colorLabels   = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M'];
    const clarityLabels = ['IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'I1', 'I2', 'I3'];

    // Context first so layerparam is available for useState initializers below
    const { client_code, layerparam, updateLayerParams, flags, esterllaFlag} = useContext(GlobalContext);
    const _dp = layerparam['DiamondPageList'];
    console.log('_dp', _dp);

    const marks = useMemo(() => {
        if (client_code === 'W284') {
            return ['0.50','0.75','1.00','1.25','1.50','1.75','2.00','2.50','3.00','3.50','4.00','5.00','6.00','7.00','8.00'];
        }
        return ['0.50','0.75','1.00','1.25','1.50','1.75','2.00','3.00'];
    }, [client_code]);
    const stoneSizeMarks = marks.reduce((acc, label, idx) => { acc[idx] = label; return acc; }, {});

    // State to manage filter inputs
    const [stoneSize, setStoneSize] = useState(_dp?.carat ?? '1.00');
    const [stoneType, setStoneType] = useState('all');
    const [itemCode, setItemCode] = useState('');
    const [clarityRangeIndex, setClarityRangeIndex] = useState(_dp?.clarity ?? [0, 9]);
    const [clarityRange, setClarityRange] = useState(
        _dp?.clarity
            ? clarityLabels.slice(_dp.clarity[0], _dp.clarity[1] + 1)
            : [...clarityLabels]
    );
    const colorAllValues = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M'];
    const clarityAllValues = ['IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'I1', 'I2', 'I3'];

    const [selectedColors, setSelectedColors] = useState(
        colorAllValues.reduce((acc, c) => ({ ...acc, [c]: true }), {})
    );
    const [selectedClarities, setSelectedClarities] = useState(
        clarityAllValues.reduce((acc, cl) => ({ ...acc, [cl]: true }), {})
    );

    const toggleColor = (c) => {
        const updated = { ...selectedColors, [c]: !selectedColors[c] };
        setSelectedColors(updated);
        pushFilterChangeEvent({ color: colorAllValues.filter(cc => updated[cc]) });
    };
    const toggleClarity = (cl) => {
        const updated = { ...selectedClarities, [cl]: !selectedClarities[cl] };
        setSelectedClarities(updated);
        pushFilterChangeEvent({ clarity: clarityAllValues.filter(ccl => updated[ccl]) });
    };
    const [tableDiamondData, setTableDiamondData] = useState([]);
    const [certificateType, setCertificateType] = useState(`all`);
    const [certificate, setCertificate] = useState(`all`);

    const [colorRangeIndex, setColorRangeIndex] = useState(
        _dp?.color
            ? [colorLabels.indexOf(_dp.color[0]), colorLabels.indexOf(_dp.color[1])]
            : [0, colorLabels.length - 1]
    );
    const [colorRange, setColorRange] = useState(_dp?.color ?? ['D', 'M']);
    const colorMarks = colorLabels.reduce((acc, label, idx) => {
        acc[idx] = label;
        return acc;
    }, {});

    const clarityMarks = clarityLabels.reduce((acc, label, idx) => {
        acc[idx] = label;
        return acc;
    }, {});

    const [loading, setLoading] = useState(false); // Loading state for fetching data

    // When "All" is selected and the client has restricted cert types,
    // send the actual allowed values instead of the string 'all'.
    const getEffectiveCertType = (selected) => {
        const clientRestrictions = CERT_OPTIONS_BY_CLIENT[client_code];
        if (selected === 'all' && clientRestrictions) {
            return clientRestrictions.filter(v => v !== 'all');
        }
        return selected;
    };
    const [stoneShape,setStoneShape] = useState(layerparam['Layer 1']?.StoneShape || 'Round');
    const [colorCode, setColorCode] = useState(layerparam['Color Code']?.color_code || '#005388');
    console.log('colorCode', colorCode);
    const themeColor = Array.isArray(colorCode) ? colorCode[0] : colorCode;

    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(client_code== 'W284' ? 3 : 10); // Default limit
    const [totalRows, setTotalRows] = useState(0); // Total number of rows

    // State to manage modal visibility and selected item data
    const [modalDiamondDetailsOpen, setModalDiamondDetailsOpen] = useState(false);
    const [diamondDetails, setDiamondDetails] = useState(null); // Store diamond details
    const [diamondDetailsTemp, setDiamondDetailsTemp] = useState();
    const [diamondDetailsPricesTemp, setDiamondDetailsPricesTemp] = useState();
    const [isFetching, setIsFetching] = useState(false);



    // Fetch data function with pagination and filters
    const fetchDiamonds = async (pageToFetch = 1, currentLimit = limit, appendData = false) => {
        if (isFetching) return;

        setIsFetching(true);
        setLoading(true);
        const baseUrl = `${CONSTANT.BASE_URL}api/Builder/all-diamonds`;
        try {
            const response = await axios.post(baseUrl, {
                request_type: 'ajax',
                carat_size: stoneSize,
                item_code_filter: itemCode,
                certificate_filter: certificate,
                shape: stoneShape,
                natural_lab_filter: stoneType,
                color_filter: colorAllValues.filter(c => selectedColors[c]),
                clarity_filter: clarityAllValues.filter(cl => selectedClarities[cl]),
                certificateType: getEffectiveCertType(certificateType),
                account: client_code,
                page: pageToFetch,
                limit: currentLimit
            });

            const newDiamonds = Array.isArray(response.data.data) ? response.data.data : [];
            const total = response.data.total_diamonds_found || 0;

            // Append data when loading more pages, replace when it's a fresh search
            let totalLoaded = 0;
            if (appendData && pageToFetch > 1) {
                setTableDiamondData(prev => {
                    const updated = [...prev, ...newDiamonds];
                    totalLoaded = updated.length;
                    return updated;
                });
            } else {
                setTableDiamondData(newDiamonds);
                totalLoaded = newDiamonds.length;
            }
            setTotalRows(total);
        } catch (error) {
            console.error('Error fetching diamond data:', error);
            setTableDiamondData([]);
            setTotalRows(0);
        } finally {
            setLoading(false);
            setIsFetching(false);
        }
    };

    const handleDiamondDetails = async (data) => {
        setDiamondDetailsTemp(data);
        setDiamondDetailsPricesTemp(data?.prices);
        setModalDiamondDetailsOpen(true); // Open the modal
    }

    // This modal has no shape or cut selector, and no price_range control — only
    // carat/color/clarity actually change here (mirrors DiamondListPage's diamond search).
    // color/clarity default to the actually-applied filter (selectedColors/selectedClarities),
    // since the desktop range sliders and mobile toggle buttons are separate, independently
    // editable controls for the same filter.
    const pushFilterChangeEvent = (overrides = {}) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'ring_builder_filter_change',
            shape: overrides.shape ?? stoneShape,
            carat: overrides.carat ?? stoneSize,
            color: overrides.color ?? colorAllValues.filter(c => selectedColors[c]),
            clarity: overrides.clarity ?? clarityAllValues.filter(cl => selectedClarities[cl]),
            customer_number: client_code,
            retailer_domain: window.location.hostname,
        });
    };

    const handleColorRangeChange = (range) => {
        setColorRangeIndex(range);
        const updatedColorRange = [
            colorLabels[range[0]],
            colorLabels[range[1]],
        ];
        setColorRange(updatedColorRange);
        pushFilterChangeEvent({ color: updatedColorRange });
    };

    const handleStoneSizeChange = (index) => {
        setStoneSize(marks[index]);
        pushFilterChangeEvent({ carat: marks[index] });
        onStoneSizeChange?.(marks[index]);
    };

    const handleStoneTypeChange = (value) => {
        setStoneType(value);
        pushFilterChangeEvent();
    };

    const handleCertificateTypeChange = (value) => {
        setCertificateType(value);
        pushFilterChangeEvent();
    };

    const handleReset = () => {
        setStoneSize('1.00');
        setStoneType('all');
        setItemCode('');
        setColorRange([`D`,`M`]);
        setSelectedColors(colorAllValues.reduce((acc, c) => ({ ...acc, [c]: true }), {}));
        setSelectedClarities(clarityAllValues.reduce((acc, cl) => ({ ...acc, [cl]: true }), {}));
        setCertificateType('all');
        setClarityRangeIndex([0, 9]);
        setClarityRange(['IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'I1', 'I2', 'I3']);
        setCurrentPage(1);
        setLimit(10);
        // Need to fetch after state updates, so use setTimeout
        setTimeout(() => fetchDiamonds(1, 10, false), 0);
    }

    const handleChangeClarityRange = (range) => {
        setClarityRangeIndex(range);
        const updatedClarityRange = clarityLabels.slice(range[0], range[1] + 1);
        setClarityRange(updatedClarityRange);
        pushFilterChangeEvent({ clarity: updatedClarityRange });
    }

    // Auto-refresh when filters change (non-W284 only — W284 uses AIRecommendedDiamonds)
    useEffect(() => {
        if (client_code !== 'W284') {
            setCurrentPage(1);
            fetchDiamonds(1, limit, false);
        }
    }, [stoneSize, stoneType, colorRange, clarityRange, certificateType, selectedColors, selectedClarities]); // eslint-disable-line

    // Lock body scroll when modal is open
    useEffect(() => {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.style.height = '100vh';
        return () => {
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
            document.body.style.height = '';
        };
    }, []);

    // Function to close the modal
    const closeDiamondModal = () => {
        setModalDiamondDetailsOpen(false); // Close the modal
        setDiamondDetails(null); // Clear the details when closing
    };

    const closeAllModel = (diamondDetails) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'ring_builder_diamond_selected',
            diamond_id: diamondDetailsTemp?.stock_num,
            shape: diamondDetailsTemp?.shape,
            carat: diamondDetailsTemp?.carat,
            color: diamondDetailsTemp?.color,
            clarity: diamondDetailsTemp?.clarity,
            price: parseFloat(String(diamondDetailsPricesTemp).replace(/[$, ]/g, '')),
            customer_number: client_code,
            retailer_domain: window.location.hostname,
        });
        handleSelectedDiamondDetails(diamondDetailsTemp)
        setModalDiamondDetailsOpen(false); // Close the modal
        setDiamondDetails(null); // Clear the details when closing
        toggleDiamondModal();
        if(diamondDetailsTemp != null && diamondDetailsTemp != undefined && diamondDetailsTemp != ""){
            updateLayerParams('Diamond Details','diamond_details',diamondDetailsTemp);
            updateLayerParams('Diamond Details','diamond_prices',diamondDetailsPricesTemp);
        }
    }

    const hideDiamondColumn = flags?.['HIDE_DIAMOND_COLUMN'] && flags?.['HIDE_DIAMOND_COLUMN'] != 'No';
    const hideDiamondPrice = isDiamondPriceHidden(flags);

    const columns = [
        ...(!hideDiamondColumn ? [{
            name: "Item Code",
            selector: (row) => row?.stock_num || "N/A",
            sortable: true,
            cell:(row) => (
                <a
                    href="#"
                    data-target=""
                    onClick={() => handleDiamondDetails(row)} // Correct: Pass as a callback
                >
                    {row?.stock_num || "N/A"}
                </a>
            ),
        }] : []),
        { name: "Lab/Natural", selector: (row) => row?.diamond_type || "N/A", sortable: true },
        { name: "Shape", selector: (row) => row?.shape || "N/A", sortable: true },
        { name: "Size", selector: (row) => row?.size || "N/A", sortable: true },
        { name: "Color", selector: (row) => row?.color || "N/A", sortable: true },
        { name: "Clarity", selector: (row) => row?.clarity || "N/A", sortable: true },
        ...(!hideDiamondColumn ? [
            { name: "Cut", selector: (row) => row?.Cut || "N/A", sortable: true },
            { name: "Depth%", selector: (row) => row?.depth || "N/A", sortable: true },
            { name: "Table%", selector: (row) => row?.table || "N/A", sortable: true },
        ] : []),
        { name: "Measurements", selector: (row) => row?.measurement || "N/A", sortable: true },
        { name: "Cert Lab", selector: (row) => row?.Lab || "N/A", sortable: true },
        {
            name: "Certificate#",
            selector: (row) => row?.certificate || "N/A",
            sortable: true,
            // Estrella: certificate# opens the diamond details modal so the diamond can be added
            ...(esterllaFlag && {
                cell: (row) => (
                    <a href="#" onClick={(e) => { e.preventDefault(); handleDiamondDetails(row); }}>
                        {row?.certificate || "N/A"}
                    </a>
                ),
            }),
        },
        ...(!hideDiamondPrice ? [{ name: "MSRP", selector: (row) => row?.display_pricing || "N/A", sortable: true }] : []),
    ];
    const modalContent = (
        <div className="diamond-modal-overlay">
            <div className="modal-content">
            {modalDiamondDetailsOpen ? (
                <>
                    <DiamondDetailsModal
                        closeDiamondModal={closeDiamondModal}
                        closeAllModel={closeAllModel}
                        diamondDetailsTemp={diamondDetailsTemp}
                        diamondDetailsPricesTemp={diamondDetailsPricesTemp}
                        colorCodes={colorCode}
                    />
                </>
            ):(
                <>
                    <div className="modal-header adm-header" style={{ background: themeColor }}>
                        <div className="adm-header__left">
                            <div className="adm-header__icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                                </svg>
                            </div>
                            <div>
                                <h4 className="adm-header__title">Recommended Diamonds</h4>
                                <p className="adm-header__subtitle">Select your center stone</p>
                            </div>
                        </div>
                        <button type="button" onClick={toggleDiamondModal} className="adm-header__close">×</button>
                    </div>
                    <div className='modal-body adm-body'>
                        <div className='row grid-row'>
                            <div className='col-12 col-sm-12 col-md-12 col-lg-12'>
                                <div className='row'>
                                    <div className='col-12 col-sm-12 col-md-12 col-lg-12'>
                                        {/* Filters */}
                                        <div className="filters row">
                                            <div className="filter-item col-12 col-sm-6 col-md-6 col-lg-6">
                                                <label>Stone Size</label>
                                                {/* Desktop: slider */}
                                                <div className="d-none d-sm-block adm-slider-wrap">
                                                    <Slider
                                                        min={0}
                                                        max={marks.length - 1}
                                                        step={1}
                                                        value={marks.indexOf(stoneSize)}
                                                        onChange={handleStoneSizeChange}
                                                        marks={stoneSizeMarks}
                                                        dotStyle={{ borderColor: colorCode[0] }}
                                                        activeDotStyle={{ borderColor: colorCode[0] }}
                                                        trackStyle={{ backgroundColor: colorCode[0], height: 4 }}
                                                        handleStyle={{ borderColor: colorCode[0], height: 24, width: 24, marginTop: -10, backgroundColor: colorCode }}
                                                        railStyle={{ backgroundColor: colorCode[0], height: 4 }}
                                                    />
                                                </div>
                                                {/* Mobile: boxes */}
                                                <div className="d-flex d-sm-none flex-wrap adm-toggle-btns">
                                                    {marks.map((m) => {
                                                        const active = stoneSize === m;
                                                        return (
                                                            <button
                                                                key={m}
                                                                type="button"
                                                                onClick={() => handleStoneSizeChange(marks.indexOf(m))}
                                                                className={`adm-toggle-btn${active ? ' adm-toggle-btn--active' : ''}`}
                                                                style={{ border: active ? `2px solid ${themeColor}` : '1px solid #ccc' }}
                                                            >{m}</button>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                            <div className="filter-item col-12 col-sm-3 col-md-3 col-lg-3">
                                                <label>Lab/Natural</label>
                                                <select className="form-control" value={stoneType} onChange={(e) => handleStoneTypeChange(e.target.value)}>
                                                    <option value="all">All (Lab/Natural)</option>
                                                    <option value="Natural">Natural</option>
                                                    <option value="Lab-Grown">Lab-Grown</option>
                                                </select>
                                            </div>
                                            <div className="filter-item col-12 col-sm-3 col-md-3 col-lg-3">
                                                <label>Item Code</label>
                                                <input type="text" className="form-control" placeholder="Enter Item Code" value={itemCode} onChange={(e) => setItemCode(e.target.value)} onPaste={(e) => { e.stopPropagation(); setItemCode(e.clipboardData.getData('text')); }} />
                                            </div>
                                            {client_code == 'W284' ? (
                                                <>
                                                    <div className="filter-item col-12 col-sm-5 col-md-5 col-lg-5">
                                                        <label className="adm-filter-label">Color</label>
                                                        {/* Desktop: slider */}
                                                        <div className="d-none d-sm-block adm-slider-wrap">
                                                            <Slider range min={0} max={colorLabels.length - 1} step={1} value={colorRangeIndex} onChange={handleColorRangeChange} marks={colorMarks} allowCross={false} dotStyle={{ borderColor: colorCode[0] }} trackStyle={[{ backgroundColor: colorCode[0], height: 4 }]} handleStyle={[ { borderColor: colorCode[0], backgroundColor: colorCode[0], height: 24, width: 24, marginTop: -10 }, { borderColor: colorCode[0], backgroundColor: colorCode[0], height: 24, width: 24, marginTop: -10 } ]} railStyle={{ backgroundColor: '#cecece', height: 4 }} style={{ width: '90%' }}
                                                            />
                                                        </div>
                                                        {/* Mobile: buttons */}
                                                        <div className="d-flex d-sm-none flex-wrap adm-toggle-btns">
                                                            {colorLabels.map((c) => {
                                                                const active = !!selectedColors[c];
                                                                return (
                                                                    <button
                                                                        key={c}
                                                                        type="button"
                                                                        onClick={() => toggleColor(c)}
                                                                        className={`adm-toggle-btn${active ? ' adm-toggle-btn--active' : ''}`}
                                                                        style={{ border: active ? `2px solid ${themeColor}` : '1px solid #ccc' }}
                                                                    >{c}</button>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                    <div className="filter-item col-12 col-sm-5 col-md-5 col-lg-5">
                                                        <label className="adm-filter-label">Clarity</label>
                                                        {/* Desktop: slider */}
                                                        <div className="d-none d-sm-block adm-slider-wrap">
                                                            <Slider range min={0} max={clarityLabels.length - 1} step={1} value={clarityRangeIndex} onChange={handleChangeClarityRange} marks={clarityMarks} allowCross={false} dotStyle={{ borderColor: colorCode[0] }} trackStyle={[{ backgroundColor: colorCode[0], height: 4 }]} handleStyle={[ { borderColor: colorCode[0], backgroundColor: colorCode[0], height: 24, width: 24, marginTop: -10 }, { borderColor: colorCode[0], backgroundColor: colorCode[0], height: 24, width: 24, marginTop: -10 } ]} railStyle={{ backgroundColor: '#cecece', height: 4 }} style={{ width: '90%' }}
                                                            />
                                                        </div>
                                                        {/* Mobile: buttons */}
                                                        <div className="d-flex d-sm-none flex-wrap adm-toggle-btns">
                                                            {clarityLabels.map((cl) => {
                                                                const active = !!selectedClarities[cl];
                                                                return (
                                                                    <button
                                                                        key={cl}
                                                                        type="button"
                                                                        onClick={() => toggleClarity(cl)}
                                                                        className={`adm-toggle-btn${active ? ' adm-toggle-btn--active' : ''}`}
                                                                        style={{ border: active ? `2px solid ${themeColor}` : '1px solid #ccc' }}
                                                                    >{cl}</button>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                    <div className="filter-item col-12 col-sm-2 col-md-2 col-lg-2">
                                                        <label>Certificate Type</label>
                                                        <select className="form-control" value={certificateType} onChange={(e) => handleCertificateTypeChange(e.target.value)}>
                                                            {(CERT_OPTIONS_BY_CLIENT[client_code]
                                                                ? ALL_CERT_OPTIONS.filter(o => CERT_OPTIONS_BY_CLIENT[client_code].includes(o.value))
                                                                : ALL_CERT_OPTIONS
                                                            ).map(o => (
                                                                <option key={o.value} value={o.value}>{o.label}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </>
                                            ):(
                                                <div className="filter-item col-12 col-sm-3 col-md-3 col-lg-3">
                                                    <label>Certificate</label>
                                                    <input type="text" className="form-control" placeholder="Enter Certificate" value={certificate} onChange={(e) => setCertificate(e.target.value)} />
                                                </div>
                                            )}
                                        </div>
                                        {/* Filters */}
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-sm-12 col-md-12 col-lg-12'>
                                {client_code == 'W284' ? (
                                    <AIRecommendedDiamonds
                                        account={client_code}
                                        shape={stoneShape}
                                        onSelect={handleDiamondDetails}
                                        stoneSize={stoneSize}
                                        stoneType={stoneType}
                                        certificateType={certificateType}
                                        itemCode={itemCode}
                                        selectedColors={colorAllValues.filter(c => selectedColors[c])}
                                        selectedClarities={clarityAllValues.filter(cl => selectedClarities[cl])}
                                    />
                                ):(
                                    <div className='diamond-table'>
                                        <DataTable
                                            columns={columns}
                                            data={tableDiamondData}
                                            progressPending={loading}
                                            pagination
                                            paginationServer
                                            paginationTotalRows={totalRows}
                                            paginationPerPage={limit}
                                            paginationDefaultPage={currentPage}
                                            onChangePage={(page) => {
                                                setCurrentPage(page);
                                                fetchDiamonds(page, limit, false); // Fetch new page data
                                            }}
                                            onChangeRowsPerPage={(newLimit) => {
                                                setLimit(newLimit);
                                                setCurrentPage(1);
                                                fetchDiamonds(1, newLimit, false); // Fetch with new limit
                                            }}
                                            highlightOnHover
                                            responsive={true}
                                            striped
                                            fixedHeader={false}
                                            customStyles={{
                                                table: {
                                                    style: {
                                                        overflow: 'hidden', // Disable internal scroll
                                                        width:'100%'
                                                    },
                                                },
                                                cells: {
                                                    overflow : 'hidden',
                                                    whiteSpace : 'nowrap'
                                                },
                                                headCells: {
                                                    overflow : 'hidden',
                                                    style     :{
                                                        backgroundColor: colorCode[0],
                                                        color:`white`
                                                    },
                                                    whiteSpace : 'nowrap'
                                                }
                                            }}
                                        />
                                    </div>

                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}
            </div>
        </div>
    );

    return ReactDOM.createPortal(modalContent, document.body);
};
